// assets/universal-tabs-image-grid.js
(function(){
  function init(root){
    if(!root) return;

    var tabs = root.querySelectorAll('[data-utig-tab]');
    var panels = root.querySelectorAll('[data-utig-panel]');
    if(!tabs.length || !panels.length) return;

    function activate(id){
      tabs.forEach(function(btn){
        var on = btn.getAttribute('data-utig-tab') === id;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        var on = p.getAttribute('data-utig-panel') === id;
        p.classList.toggle('is-active', on);
      });
    }

    tabs.forEach(function(btn){
      btn.addEventListener('click', function(){
        activate(btn.getAttribute('data-utig-tab'));
      });
      btn.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var arr = Array.prototype.slice.call(tabs);
        var i = arr.indexOf(btn);
        var next = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if(next < 0) next = arr.length - 1;
        if(next >= arr.length) next = 0;
        arr[next].focus();
        activate(arr[next].getAttribute('data-utig-tab'));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.section-universal-tabs-image-grid').forEach(function(section){
      init(section);
    });
  });
})();
